import { useState } from "react";
import { Input } from "./Form";
import Icon from "./Icon";

function SearchBar({
  containerClassName = "",
  className = "",
  onChange,
  initialQuery = "",
  hide = false,
  value,
  ...rest
}) {
  const [text, setText] = useState(initialQuery);
  const currentText = value ?? text;

  return (
    <div className={`relative ${containerClassName}`}>
      <Input
        value={currentText}
        onChange={(e) => {
          let text = e.target.value;
          setText(text);
          if (onChange) {
            onChange(text);
          }
        }}
        className={`
          ${className} cursor-pointer w-full pl-8 pr-4 block search-bar
               `}
        autoCorrect="none"
        autoCapitalize="none"
        spellCheck="none"
        {...rest}
      />
      <div className="absolute left-0 top-0 bottom-0 w-8 flex items-center justify-center">
        🔍
      </div>
      <div
        className={`absolute right-0 px-2 top-0 h-full items-center cursor-pointer animate-ease-2 text-gray-600 hover:text-gray-900 active:text-gray-800
              ${String(currentText).trim() === "" ? "opacity-0 invisible" : "opacity-100 visible"}
               ${hide ? "hidden" : "flex"}
               `}
        onClick={() => {
          setText("");
          if (onChange) {
            onChange("");
          }
        }}
      >
        <Icon icon="close" size={12} />
      </div>
    </div>
  );
}

export default SearchBar;
